//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Captcha from '@/utils/captcha';
import {
  GetSecurityCodeBySms,
  CreateStoreUserWithSecurityCode,
} from '@/service/request';

export default {
  data() {
    return {
      phone: '',
      codeValue: '',
      isCaptchaSuccess: false,
      time: 3,
      isTimeover: true,
      password: '',
      jumpUrl1: '',
      jumpUrl2: '',
      protocolName: '',
      hasGotCode: false, //已经获取过验证码
    };
  },

  computed: {
    isRegDisbaled() {
      return (
        this.codeValue === '' ||
        !this.verifyPhone(this.phone) ||
        !this.verifyPassword(this.password)
      );
    },
    isCodeDisabled() {
      return !this.verifyPhone(this.phone) || !this.isTimeover;
    },
    regParams() {
      let storeUserJson = {
        account: this.phone,
        password: this.password,
        email: `${this.phone}@pospal.cn`,
        address: '福建省厦门市XXX',
        tel: this.phone,
        company: this.phone,
        industry: '零售行业',
        source:
          typeof this.$route.query.source !== 'undefined'
            ? this.$route.query.source
            : 'mowen',
      };

      return {
        storeUserJson: JSON.stringify(storeUserJson),
        securityCode: this.codeValue,
      };
    },
  },

  methods: {
    setLocalSecrecy() {
      this.$vux.toast.show({
        type: 'text',
        text: '<div class="toast-content"><p>注册成功</p></div>',
        time: 1500,
        width: '12.5rem',
        isShowMask: true,
        onHide: () => {
          this.$router.push('/step01');
        },
      });

      let secrecy = {
        account: this.phone,
        password: this.password,
        expires: new Date().getTime() + 2 * 60 * 60 * 1000,
      };
      this.$store.commit('SET_SECRECY', secrecy);
    },
    verifyPassword(value) {
      let re = /^[^\s]{6,32}$/;
      return re.test(value);
    },
    handleCodeClick() {
      this.getCode();
    },
    getCode() {
      this.alertPhone();

      if (this.isCodeDisabled) {
        return;
      }

      let params = {
        ...(!this.hasGotCode && this.captchaParams),
        ...(this.hasGotCode && { skipValidCaptcha: true }),
        tel: this.phone,
      };

      GetSecurityCodeBySms(params)
        .then((data) => {
          this.hasGotCode = true;
          this.countDown();
        })
        .catch(() => {});
    },
    countDown() {
      let time = 180;
      this.time = time;
      this.isTimeover = false;
      let timer = setInterval(() => {
        this.time -= 1;
        if (this.time === 0) {
          clearInterval(timer);
          this.time = time;
          this.isTimeover = true;
        }
      }, 1000);
    },
    verifyPhone(value) {
      let re = /^[1][3,4,5,7,8,9][0-9]{9}$/;
      return re.test(value);
    },
    handleRegClick() {
      if (this.isRegDisbaled) {
        return;
      }
      let fromApp =
        typeof this.$route.query.fromApp !== 'undefined'
          ? this.$route.query.fromApp
          : '';
      let partner =
        typeof this.$route.query.partner !== 'undefined'
          ? this.$route.query.partner
          : '';
      CreateStoreUserWithSecurityCode(this.regParams, fromApp, partner)
        .then((data) => {
          this.setLocalSecrecy();
        })
        .catch((err) => {});
    },
    alertPhone() {
      if (this.phone === '') {
        this.$vux.alert.show({
          content: '请输入手机号码',
        });
        return false;
      }

      let passVerifyPhone = this.verifyPhone(this.phone);
      if (!passVerifyPhone) {
        this.$vux.alert.show({
          content: '手机号码格式有误',
        });
        return false;
      }

      return true;
    },
    setJumpUrl() {
      const { appName, companyName, telephone } = this.$route.query;
      if (appName) {
        // OEM协议
        let queryStr = `?appName=${appName}&companyName=${companyName}&telephone=${telephone}`;
        this.jumpUrl1 = `https://www.pospal.cn/oem/agreement/ysqzc.html${queryStr}`;
        this.jumpUrl2 = `https://www.pospal.cn/oem/agreement/yhfwxy.html${queryStr}`;
      } else {
        this.jumpUrl1 = `http://pospal.cn/landing/agree/documentation/ysq.html`;
        this.jumpUrl2 = `http://pospal.cn/landing/agree/documentation/yhfwxy.html`;
      }
    },
    setProtocolName() {
      const { appName } = this.$route.query;
      let companyName = appName || '银豹';
      this.protocolName = `${companyName}收银软件用户服务协议`;
    },
  },

  created() {
    this.setJumpUrl();
    this.setProtocolName();
  },

  mounted() {
    new Captcha({
      containerId: 'nc',
      startText: '拖动到最右边，获取验证码',
      callback: (data) => {
        this.captchaParams = data;
        this.isCaptchaSuccess = true;

        this.getCode();
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/views/home/home.vue